import { Component, Input } from '@builder.io/sdk';

import { moleculeHeadingFields } from 'molecules/Heading/config';
import imageField from 'molecules/Image/config';
import sectionFields from 'molecules/Section/config';

const featureSpotlightFields = [
  ...moleculeHeadingFields,
  imageField('featuredImage'),
  imageField('backgroundImage'),
  {
    name: 'imagePosition',
    type: 'string',
    defaultValue: 'right',
    enum: [
      { label: 'Right', value: 'right' },
      { label: 'Left', value: 'left' },
    ],
    helperText: 'Which side the featured image sits on for desktop. Mobile always stacks image below.',
  },
  {
    name: 'showGlow',
    type: 'boolean',
    defaultValue: true,
    helperText: 'Show the soft glow ring behind the featured image.',
  },
  ...sectionFields,
] as const satisfies DeepReadonly<Input[]>;

const featureSpotlightConfig = {
  name: 'FeatureSpotlight',
  inputs: featureSpotlightFields,
} as Component;

export type FeatureSpotlightConfigProps = GenerateBuilder<typeof featureSpotlightFields>;

export default featureSpotlightConfig;
